import styled from 'styled-components';

import Icon from 'components/Icon';

const Container = styled.div`
  position: relative;
	height: 300px;
	width: 400px;
	min-width: 400px;
	cursor: pointer;
`;

const Image = styled.div`
  background-image: url(${ props => props.image });
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-color: white;
  margin: 0;
  z-index: 1;
  box-shadow: 0px 20px 40px -20px rgba(0,0,0,0.3);
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  transform: translate(0px, 0px);
  transition: all 0.2s ease-out;
	overflow: hidden;

	&:before {
		content: "";
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		background-color: rgba(242,242,242,0);
	}

  &:nth-child(3) {
		z-index: 1;
    &:before {
      background-color: rgba(242,242,242,0.9);
    }
  }

  &:nth-child(2) {
    box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.4);
		transition: box-shadow 0.1s ease-out, transform 0.2s ease-out;
		z-index: 2;

		&:before {
      background-color: rgba(242,242,242,0.5);
    }
  }

  &:nth-child(1) {
    box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.4);
		transition: box-shadow 0.1s ease-out, transform 0.2s ease-out;
		z-index: 3;
  }

  ${Container}:hover & {
    &:nth-child(3) {
      transform: translate(8px, 8px);
    }

    &:nth-child(2) {
      box-shadow: 0px 4px 8px -2px rgba(0,0,0,0.3);
    }

    &:nth-child(1) {
      transform: translate(-8px, -8px);
      box-shadow: 0px 4px 8px -2px rgba(0,0,0,0.3);
    }
  }
}
`;

const ImageIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  fill: white;
`;

const P = styled.p`
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 1;
  transition: all 0.3s ease-out;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 4;
  transform: translate(0px, 0px);
  transition all 0.2s ease-out;
  background-color: rgba(0,0,0,0.3);
  padding: 4px;
  border-radius: 4px;

  ${Container}:hover & {
    transform: translate(-8px, -8px);
	}

	span {
		margin-left: 8px;
	}
`;

export {
	Container,
	Image,
	ImageIcon,
	P
}
